<template>
  <section class="section">
    <div class="container">
      <h1 class="title has-text-centered">
        Import d'un projet
      </h1>

      <b-field class="file is-primary" :class="{'has-name': !!file}">
        <b-upload v-model="file" class="file-label">
                            <span class="file-cta">
                                <b-icon class="file-icon" icon="upload"></b-icon>
                                <span class="file-label">Importer une sauvegarde</span>
                            </span>
          <span class="file-name" v-if="file">
                                {{ file.name }}
                            </span>
          <span>
                                <b-button type="is-danger"
                                          v-if="file"
                                          icon-right="trash"
                                          @click.prevent="deleteFile()"/>
                    </span>
        </b-upload>
      </b-field>
      <b-button type="is-success"
                v-if="file"
      @click.prevent="controlFile()">
        Importer dans l'interface
      </b-button>

    </div>
  </section>
</template>

<script>
export default {
  name: "Import",
  methods: {
    controlFile() {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.load(e.target.result);
      }
      reader.readAsText(this.file);
    },
    deleteFile() {
      this.file = null;
    },
    load(i) {
      let j = JSON.parse(i)
      localStorage.setItem("project",JSON.stringify(j.project));
      localStorage.setItem("td",JSON.stringify(j.td ? j.td : []));
      localStorage.setItem("fm",JSON.stringify(j.fm ? j.fm : []));
      localStorage.setItem("mat",JSON.stringify(j.mat ? j.mat : []));
      localStorage.setItem("sst",JSON.stringify(j.sst ? j.sst : []));
      localStorage.setItem("fi",JSON.stringify(j.fi ? j.fi : []));
      localStorage.setItem("p1",JSON.stringify(j.p1 ? j.p1 : ""));
      localStorage.setItem("p2" ,JSON.stringify(j.p2 ? j.p2 : ""));
      this.$router.push('/projet')
    }
  },
  data() {
    return {
      file: null,
    }
  }
}
</script>

<style scoped>

</style>